import { EntityId, EntityIdParams } from '@Models';

export class ArmyListView extends EntityId<string> {
  logo: string | null;
  initials: string;
  versionName: string;
  versionColor: string;

  constructor(params: ArmyListViewParams) {
    super(params);
    this.logo = params.logo ?? null;
    this.initials = params.initials ?? '';
    this.versionName = params.versionName;
    this.versionColor = params.versionColor;
  }
}

export type ArmyListViewParams = EntityIdParams<string> & {
  logo: string | null;
  initials: string | null;
  versionName: string;
  versionColor: string;
};
